import { useMemo } from 'react'

export const useNormCategories = () => {
  const categories = useMemo(() => ['NIST', 'ISO_13', 'ISO_22', 'NIS2', 'SOC', 'SWIFT', 'SAMA'], [])
  const industrialApplicableFrameworks = useMemo(
    () => ['NIST', 'ISO_13', 'ISO_22', 'NIS2', 'SOC', 'SWIFT', 'SAMA'],
    []
  )

  return { categories, industrialApplicableFrameworks }
}
